import { render, staticRenderFns } from "./member_welfare.vue?vue&type=template&id=663a8db0&scoped=true&"
import script from "./member_welfare.vue?vue&type=script&lang=ts&"
export * from "./member_welfare.vue?vue&type=script&lang=ts&"
import style0 from "./member_welfare.vue?vue&type=style&index=0&id=663a8db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663a8db0",
  null
  
)

export default component.exports